import React, { createContext, useContext, useState, ReactNode, useEffect } from "react";

type AuthContextType = {
  token: string;
  setToken: (token: string) => void;
  isLoggedIn: boolean;
  logout: () => void;
};

const AuthContext = createContext<AuthContextType>({
  token: "",
  setToken: () => {},
  isLoggedIn: false,
  logout: () => {},
});

type Props = { children: ReactNode };

export const AuthProvider = ({ children }: Props) => {
  const [token, setTokenState] = useState("");

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      setTokenState(storedToken);
    }
  }, []);

  const setToken = (token: string) => {
    setTokenState(token);
    localStorage.setItem("token", token);
  };

  const logout = () => {
    setTokenState("");
    localStorage.removeItem("token");
  };

  return (
    <AuthContext.Provider
      value={{ token, setToken, isLoggedIn: !!token, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
